import { DeprecatedFormId } from '@furnish-hx/constants/FormId';
import FormTypeId from '@core/constants/FormTypeId';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import fieldPortfolioData from './common/fieldsPortfolioData';
import {
    IFormFieldKey,
    IFormInputType,
    IDimensionUnit,
    IForm,
} from '../../interfaces/Form';
import fieldsContact from './common/fieldsContact';
import { additionalDataFactory } from './common/fieldsAdditionalData';
import {
    fieldsGlassWallClosingTypes,
    fieldsGlassWallDimension, fieldsGlassWallFrameMaterial, fieldsGlassWallOptions, fieldsGlassWallStyle, fieldsGlassWallWindowMaterial,
} from './common/fieldsGlassWalls';

const glassWallWithBaseForm: IForm = {
    formId       : DeprecatedFormId.GlassWallWithBase,
    type         : FormTypeId.GlassWall,
    thumbnailURL : '/resized-images/forms/glassWallWithBase.jpg',
    fieldsOrder  : [
        IFormFieldKey.PortfolioData,
        IFormFieldKey.Comment,
        IFormFieldKey.WindowMaterial,
        IFormFieldKey.FrameMaterial,
        IFormFieldKey.Dimension,
        IFormFieldKey.GlassWallStyle,
        IFormFieldKey.Openings,
        IFormFieldKey.ClosingType,
        IFormFieldKey.AdditionalData,
        IFormFieldKey.Contact,
    ],
    fields: {
        portfolioData : fieldPortfolioData,
        comment       : {
            comment: {
                value    : undefined,
                required : false,
            },
        },
        windowMaterial : fieldsGlassWallWindowMaterial,
        frameMaterial  : fieldsGlassWallFrameMaterial,
        dimension      : {
            ...fieldsGlassWallDimension,
            [FieldDimensionId.HeightBase]: {
                value        : undefined,
                type         : IFormInputType.Range,
                unit         : IDimensionUnit.Centimeters,
                step         : 100,
                range        : { min: 100, max: 2000 },
                required     : true,
                defaultValue : 1000,
            },
        },
        glassWallStyle : fieldsGlassWallStyle,
        openings       : fieldsGlassWallOptions,
        closingType    : fieldsGlassWallClosingTypes,
        additionalData : additionalDataFactory(),
        contact        : fieldsContact,
    },
};

export default glassWallWithBaseForm;
